import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { LayoutManager, Authentication } from './components';
import { routes } from './routes';
import { configService } from './services';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import CookieConsent from 'react-cookie-consent';
import { Helmet } from 'react-helmet';
import i18n from "./i18n"

export const App: React.FC = () => {

  let appId = process.env.REACT_APP_CLIENTID;

  useEffect(() => {
    // Load the CSS file based on the provided ID
    import(`../src/style/${appId}/index.scss`)
      .then(() => {
        console.log(`CSS for ${appId} loaded successfully`);
      })
      .catch((err) => {
        console.error(`Failed to load CSS for ${appId}`, err);
      });
  }, [appId]);

  const t = i18n.t;
  console.log(`Application: ${t("app_name")}`);
  console.log("Current language:", i18n.language);

  const supportedLanguages = Object.keys(i18n.services.resourceStore.data);
  const codes = supportedLanguages.filter(lng => lng !== 'cimode');

  // 2. Map the codes to their native names
  const languageList = codes.map(code => {
    try {
      // We pass the [code] itself so it returns the name in that language
      const generator = new Intl.DisplayNames([code], { type: 'language' });
      let nativeName = generator.of(code) || code;
      const formattedName = nativeName.charAt(0).toUpperCase() + nativeName.slice(1);
      return {
        code: code,
        nativeName: formattedName
      };
    } catch (e) {
      // Fallback to the code if the browser can't resolve the name
      return { code: code, nativeName: code };
    }
  });

  console.log("Supported languages:", languageList);


  return (
    <div className={`${appId}`}>
      <Helmet>
        <link rel="shortcut icon" href={`/images/${appId}/favicon.ico`} type="image/x-icon" />
      </Helmet>
      <BrowserRouter>
        <Authentication>
          <ThemeProvider theme={configService.current().theme}>
            <Routes>
              <Route element={<LayoutManager />}>
                {routes.map((route, inx) => {
                  const Component = route.component;

                  return (
                    <Route key={inx} path={route.to} element={<Component />}>
                      {route.nestedRoutes && route.nestedRoutes.map((nestedRoute, inx) => {
                        const NestedComponent = nestedRoute.component;

                        return <Route key={inx} path={`${nestedRoute.to}`} element={<NestedComponent />} />
                      })}
                    </Route>
                  )
                })}
              </Route>
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              theme="light"
            />
            <CookieConsent
              location="bottom"
              buttonText={t("cookie_consent_confirm")}
              cookieName={`${configService.current().clientId}-cookieconsent`}
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              expires={150}
            >
              <div dangerouslySetInnerHTML={{
                __html: t("cookie_consent_message")
              }} ></div>
            </CookieConsent>
          </ThemeProvider>
        </Authentication>
      </BrowserRouter>
    </div>
  );
}
